import RegisterError from "../common/register-error";

export default function Input({
  className = "",
  type,
  label,
  value,
  onChange,
  errorCode,
}) {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && <label className="font-normal">{label}</label>}
      <input
        onChange={(e) => onChange(e)}
        type={type}
        value={value}
        defaultValue={value}
        className={`rounded-md p-2.5 max-w-[350px] border ${
          errorCode
            ? "border-[#ff4900]"
            : "border-altgray-200 focus:border-[#bee0fd]"
        }`}
      />
      {errorCode && <RegisterError errorCode={errorCode} />}
    </div>
  );
}


